import { useParams } from 'react-router-dom';
import { useAuth } from '@actschurch/ccms-sdk';
import { roleFromSlug } from '@/components/common/CampusRole';

export function useCampusParam() {
  const { campus = '' } = useParams<{ campus: string }>();
  const { state } = useAuth();
  const roles: string[] = state.user?.roles ?? [];

  // Exact match on the role. Admins can be allowed too if you want that.
  const allowed = roles.includes(roleFromSlug(campus));
  // "CapeTown" -> "Cape Town"
  const campusLabel = campus.replace(/([a-z])([A-Z])/g, '$1 $2');

  return { campus, campusLabel, allowed };
}